import React, { Component } from 'react';
import './css/App.css';
import './css/bootstrap.min.css';
import { Form, FormGroup, Col, FormControl, Button , PageHeader} from 'react-bootstrap';
import Base, {App} from './rebase';
import Firebase from 'firebase';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      error: ""
    }
    this.handleLogin = this.handleLogin.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
  }
  
  handleLogin(event) {
    fetch('/authenticate', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'username': this.state.username,
        'password': this.state.password,
      }  
    })
    .then(response => response.json())
    .then(responseJson => Firebase.auth().signInWithCustomToken(responseJson.jwt))
    .then(() => {
      this.props.setLogin(true);
    })
    .catch(error => {
      this.state.error = "Wrong username password combination"
      console.log(error);
    })
    event.preventDefault();
  }

  handleUsernameChange(event) {
    this.setState({username: event.target.value})
  }

  handlePasswordChange(event) {
    this.setState({password: event.target.value});
  }

  render() {
    return (
      <div className="container">
          <PageHeader style={{textAlign: "center"}}>Welcome to Rebecca and Matthew's Wedding Website</PageHeader>
          <Col xs={10} xsOffset={1} sm={8} smOffset={2} md={4} mdOffset={4}>
          <p Style={"margin:40px 0px 40px 0px"}>If you don't have a username or password please contact Rebecca or Matthew</p>
          <Form horizontal onSubmit={this.handleLogin} >
            <FormGroup controlId="formHorizontalUsername">
              <Col>
                <FormControl type="text" placeholder="username" onChange={this.handleUsernameChange}/>
              </Col>
            </FormGroup>

            <FormGroup controlId="formHorizontalPassword">
              <Col>
                <FormControl type="password" placeholder="password" onChange={this.handlePasswordChange}/>
              </Col>
            </FormGroup>
            <p Style={"color:red"}>{this.state.error}</p>
            <FormGroup>
              <Col xsOffset={4} xs={8}>
                <Button type="submit">
                  Login
                </Button>
              </Col>
            </FormGroup>
          </Form>
          </Col>
        </div>
      );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/Login.jsx